import React from 'react';
import { Link } from 'react-router-dom';

export default function Home(){
  return (
    <div>
      <section className="hero">
        <div className="hero-left">
          <h1>Honest game reviews, quick reads</h1>
          <p>Curated reviews with ratings, platforms and quick summaries. Read, review, and explore.</p>
        </div>
        <div>
          <Link to="/react-projects/gamerfrog/reviews" className="btn">Browse Reviews</Link>
        </div>
      </section>

      <section className="grid">
        <div className="card">
          <h3>Community</h3>
          <p className="meta">Share your thoughts — write a review and help other players decide.</p>
        </div>
        <div className="card">
          <h3>Platforms</h3>
          <p className="meta">PC, PlayStation, Xbox, Switch — filter by platform when browsing.</p>
        </div>
        <div className="card">
          <h3>Curated Lists</h3>
          <p className="meta">Top rated, newest, and genre-focused lists coming soon.</p>
        </div>
      </section>
    </div>
  );
}
